export default __webpack_public_path__ + "static/media/006-pancakes.90b9061d.svg";